// extracted by mini-css-extract-plugin
export default {"suggestions_wrapper":"O8Ra_vzG42P3EaRKqwPm","input_wrapper":"CXIFyWFg_WIUXQezDxIa","dark":"FRzzYHZ_JV5IHillHXWe","auto_suggest":"O7q1IEpgtzP2m_gKaq16","rtl":"ifhKl4Ii541AsqxyMgNQ"};